export const FORWARD_MAIL_VERTICAL_DETAILS = '/forward-mail/';
export const FORWARD_MAIL_BASE_PATH = '/forward-mail/move-info/';
export const FORWARD_MAIL_FIRST_SCREEN =
  '/forward-mail/move-info/confirm-addresses';
export const FORWARD_MAIL_FORMS_SUBMITED = '/forward-mail/submitted-forms';
export const FORWARD_MAIL_FORM_REVIEW = '/forward-mail/move-info/review';

export const FORWARD_MAIL_RECEIPT_PATH = '/forward-mail/receipts/';
export const FORWARD_MAIL_FORM_NAME = '/forward-mail/move-info/name';

// TODO add more analytics events later, when defined
export enum AnalyticsEvents {
  REVIEW = 'async_forward_mail_review',
}
